import React, { useEffect } from 'react';

const ClickBankTrustBadge: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//cbtb.clickbank.net/?vendor=betoracle';
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default ClickBankTrustBadge; 